import "./membershipLandingPage.scss";

import { useEffect, useState } from "react";
import MembershipListCard from "./MembershipListCard";
import Typography from "../../../../../common/Typography";
import SubscribedMembListCard from "./SubscribedMembListCard";
import isEmpty from "../../../../../../utils/constants/isEmpty";
import SingleMembershipLandingPage from "./SingleMembershipLandingPage";
import TabSelectButtonGroup from "../../../../../common/Buttons/TabSelectButtonGroup";

// memberships = array of memberships
const MembershipLandingPage = ({
  subsMembs,
  isShortlink,
  memberships,
  currencyView,
  membPurchaseDetails,
}) => {
  const [currMemb, setCurrMemb] = useState({});
  const [membershipTab, setMembershipTab] = useState("all"); // all, subscribed
  const [isMultiMembrshpPage, setMultiMembrshpPage] = useState(false);

  useEffect(() => {
    if (memberships?.length > 1) setMultiMembrshpPage(true);
    else if (memberships?.length === 0 && subsMembs > 1) {
      setMultiMembrshpPage(true);
      setMembershipTab("subscribed");
    } else {
      const singleMemb =
        memberships?.length === 1
          ? memberships?.[0]
          : subsMembs?.length === 1
          ? subsMembs[0]
          : {};
      setCurrMemb(singleMemb);
    }
  }, [memberships]);

  useEffect(() => {
    if (!isEmpty(currMemb) && isMultiMembrshpPage) setMultiMembrshpPage(false);
  }, [currMemb]);

  // const walletMemb = memberships.filter((memb) => memb.type === "cash_wallet");

  const allRewardBundlesMemb = memberships?.filter(
    (memb) => memb?.membership?.type === "reward_bundle"
  );
  const rewardBundlesMemb =
    membershipTab === "all" ? allRewardBundlesMemb : subsMembs;

  return (
    <div className="membership-landing-page">
      {isMultiMembrshpPage ? (
        <div className="multiple-memberships-page">
          <Typography
            weight="medium"
            size="display-xxxl"
            customClass="membership-list-page-title"
          >
            Membership
          </Typography>
          {memberships?.length === 0 && subsMembs?.length > 0 ? (
            <Typography
              size="text-sm"
              weight="semibold"
              customClass="membership-list-page-subtitle"
            >
              Subscribed
            </Typography>
          ) : subsMembs?.length > 0 ? (
            <TabSelectButtonGroup
              variant="navigation-tabs"
              activeTab={membershipTab}
              setActiveTab={(key) => setMembershipTab(key)}
              tabList={[
                {
                  key: "all",
                  text: "All",
                },
                {
                  key: "subscribed",
                  text: "Subscribed",
                },
              ]}
            />
          ) : (
            <></>
          )}
          <Typography
            size="text-sm"
            weight="semibold"
            customClass="membership-list-page-subtitle"
          >
            Reward Bundles
          </Typography>
          {rewardBundlesMemb.map((memb) =>
            membershipTab === "subscribed" ? (
              <SubscribedMembListCard
                memb={memb}
                setCurrMemb={setCurrMemb}
                key={memb?.membership_id}
              />
            ) : (
              <MembershipListCard
                currMemb={memb}
                setCurrMemb={setCurrMemb}
                key={memb?.membership?._id}
                currencyView={currencyView}
                selectedMembId={currMemb?.membership?._id}
              />
            )
          )}
        </div>
      ) : (
        <SingleMembershipLandingPage
          currMemb={currMemb}
          isShortlink={isShortlink}
          setCurrMemb={setCurrMemb}
          isShowBackBtn={memberships?.length > 1}
          membPurchaseDetails={membPurchaseDetails}
          setMultiMembrshpPage={setMultiMembrshpPage}
        />
      )}
    </div>
  );
};

export default MembershipLandingPage;
